module.exports = __webpack_public_path__ + "img/1530985952.b41e603d.jpg";